import { DocumentCategorySearchFilter } from 'src/modules/documentArchive/models/documentCategorySearchFilter';
import { DocumentCategory } from 'src/modules/documentArchive/models/documentCategory';
import AxiosInstance from './axios/interceptor';
import { PagedResult } from '../models/pagedResult';

const controller = 'DocumentCategory';

export const getAllDocumentCategorys = (searchFilter: DocumentCategorySearchFilter) => {
  return AxiosInstance.get<PagedResult<DocumentCategory>>(`${controller}`, { params: searchFilter });
};

export const getDocumentCategoryById = (id: number) => {
  return AxiosInstance.get<DocumentCategory>(`${controller}/${id}`);
};

export const createDocumentCategory = (data: DocumentCategory) => {
  return AxiosInstance.post<DocumentCategory>(`${controller}`, data);
};

export const updateDocumentCategory = (data: DocumentCategory) => {
  return AxiosInstance.put<DocumentCategory>(`${controller}`, data);
};

export const deleteDocumentCategory = (id: number) => {
  return AxiosInstance.delete(`${controller}/${id}`);
};
